
import React from "react";
import { Link } from "react-router-dom";

interface BlogBreadcrumbProps {
  title: string;
}

const BlogBreadcrumb: React.FC<BlogBreadcrumbProps> = ({ title }) => {
  return (
    <nav className="mb-6 flex flex-wrap items-center text-sm text-joerg-500 gap-y-1">
      <Link to="/" className="hover:text-primary whitespace-nowrap">Home</Link>
      <span className="mx-2">/</span>
      <Link to="/blog" className="hover:text-primary whitespace-nowrap">Blog</Link>
      <span className="mx-2">/</span>
      <span className="text-joerg-800 font-medium truncate">{title}</span>
    </nav>
  );
};

export default BlogBreadcrumb;
